import Control from "./Control.js"

export default class PlayPause extends Control {

  constructor(props, context) {
    super(props, context)
    this.classList.add("amp-playpause", true)
    this.state.altText = "MSG_PLAY"
  }

  static get contextTypes() {
    return super.contextTypes
  }

  onplaying() {
    this.setState({altText: "MSG_PAUSE"})
  }

  onpause() {
    this.setState({altText: "MSG_PLAY"})
  }

  onended() {
    this.setState({altText: "MSG_REPLAY"})
  }

  onClick() {
    const player = this.player
    switch (player.playState) {
      case "ended":
        this.plugin.replay()
      break

      case "ready":
      case "paused":
      	player.play()
      break

      default:
        player.pause()
      break
    }
  }

}
